import {createImageObject} from '../utils';
import {cloneDeep} from 'lodash';
import {
    placeHolder,
    suggestImg,
    sizeOptions,
    defaultSizeControl
} from '@/views/V2/image/expand/utils/constants.js';

export default {
    namespaced: true,
    state: {
        title: '智能扩图',
        placeHolder,
        suggestImg,
        uploadImg: [],
        displayImg: [],
        editLoading: false,
        toolBarLoading: false,
        displayAreaType: 'default',
        sizeOptions,
        sizeControl: cloneDeep(defaultSizeControl),
        pageLoadingStatus: {
            show: false,
            title: ''
        }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_MULTIPLE_STATES(state, updates) {
            for (let update of updates) {
                state[update.key] = update.value;
            }
        }
    },
    actions: {
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        updateMultipleState({commit}, data) {
            commit('UPDATE_MULTIPLE_STATES', data);
        },
        handleImgChange({commit}, {e}) {
            commit('UPDATE_COMMON_STATE', {
                key: 'uploadImg',
                value: e
            });
        },
        // 图片上传
        async handleImgChoose({commit, state}, {e}) {
            const uploadImg = e.map(item => {
                return {
                    url: item.url,
                    width: item.width,
                    height: item.height
                };
            });
            const allUploadImg = cloneDeep(state.uploadImg.concat(uploadImg));
            commit('UPDATE_COMMON_STATE', {
                key: 'uploadImg',
                value: allUploadImg
            });
        },
        // 扩图按钮提交
        async handleExpandSubmit({commit, state}, {model}) {
            commit('UPDATE_COMMON_STATE', {
                key: 'toolBarLoading',
                value: true
            });
            try {
                const {type, value} = state.sizeControl;
                const [dimensionWidth, dimensionHeight] = value.dimension.split('*').map(Number);
                const isChooseType = type === 'choose';
                const width = isChooseType ? dimensionWidth : value.customWidth;
                const height = isChooseType ? dimensionHeight : value.customHeight;
                const baseDisplayImg = state.uploadImg.map((_, index) => createImageObject({
                    recordId: index,
                    width,
                    height
                }));

                commit('UPDATE_MULTIPLE_STATES', [{
                    key: 'displayImg',
                    value: baseDisplayImg
                }, {
                    key: 'displayAreaType',
                    value: 'default'
                }]);

                const calculateDimension = (dimension, ratio) => {
                    return parseInt(Math.round(dimension * ratio), 10);
                };
                const calculateSize = (size, ratio, maxSize) => {
                    const value = calculateDimension(size, ratio);
                    return value > maxSize ? maxSize : value;
                };
                const itemParams = state.uploadImg.map(i => {
                    const ratio = +(width / i.boxW).toFixed(2);
                    const fgW = calculateSize(i.imgW, ratio, width);
                    const fgH = calculateSize(i.imgH, ratio, height);
                    const posX = calculateDimension(i.posX, ratio) + fgW > width
                    ? width - fgW : calculateDimension(i.posX, ratio);
                    const posY = calculateDimension(i.posY, ratio) + fgH > height
                    ? height - fgH : calculateDimension(i.posY, ratio);

                    return {
                        count: 1, // 每张图只生成1张扩图结果
                        desc: i.prompt || '',
                        url: i.url,
                        fgW,
                        fgH,
                        posX,
                        posY
                    };
                });
                const params = {
                    width,
                    height,
                    originImageList: itemParams,
                    ext: JSON.stringify({
                        extendFormData: {
                            uploadImg: state.uploadImg,
                            sizeControl: state.sizeControl
                        }
                    })
                };
                let displayImg = [];
                await model.imageCreate.expandImage(params, data => {
                    if (!data.records?.length) {
                        return;
                    }
                    if (data.taskStatus === 2) {
                        displayImg = data.records.map(item => createImageObject({
                            url: item.url,
                            recordId: item.recordId,
                            width,
                            height
                        }));
                    }
                    else {
                        displayImg = state.displayImg.map((i, index) => {
                            let item = data.records[index];
                            if (!item) {
                                return i;
                            }
                            return createImageObject({
                                url: item.url,
                                recordId: item.recordId,
                                width,
                                height
                            });
                        });
                    }
                    commit('UPDATE_MULTIPLE_STATES', [{
                        key: 'displayImg',
                        value: displayImg
                    }]);
                });

                return displayImg;
            }
            catch (err) {
                let displayImg = state.displayImg || [];
                displayImg = displayImg.filter(item => item.url);
                commit('UPDATE_MULTIPLE_STATES', [{
                    key: 'displayImg',
                    value: displayImg
                }]);
                throw err;
            }
            finally {
                commit('UPDATE_COMMON_STATE', {
                    key: 'toolBarLoading',
                    value: false
                });
            }
        }
    }
};
